import React from 'react';

import { faDollarSign, faEuroSign, faPoundSign } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Icon from 'click-controls/controls/form/field/common/icon';

import { ICON_POSITION } from 'click-controls/constant/enums';

import ECurrencyCode from 'tm3-core/interfaces/currency/codes';

interface IProps {
  disabled?: boolean;

  currency: string;

  position?: ICON_POSITION;
}

const FieldCurrencyIcon: React.FC<IProps> = React.memo(({ currency, disabled, position }) => {
  const iconName = React.useMemo(() => {
    switch (currency) {
      case ECurrencyCode.Sterling:
        return faPoundSign;

      case ECurrencyCode.Euro:
        return faEuroSign;

      case ECurrencyCode.USDollar:
        return faDollarSign;

      case ECurrencyCode.OZDollar:
        return faDollarSign;

      default:
        throw new Error(`[FieldCurrencyIcon] - Unknown currency: ${currency}`);
    }
  }, [currency]);

  const className = React.useMemo(() => {
    const classes = ['fa-xs'];

    if (disabled) {
      classes.push('text-gray-400');
    } else {
      classes.push('text-gray-600');
    }

    return classes.join(' ');
  }, [disabled]);

  return (
    <Icon border={true} position={position}>
      <FontAwesomeIcon icon={iconName} className={className} />
    </Icon>
  );
});

FieldCurrencyIcon.displayName = 'FieldCurrencyIcon';

FieldCurrencyIcon.defaultProps = {
  position: ICON_POSITION.Left
};

export default FieldCurrencyIcon;
